export class UserTypeEnum {
    static OPR = 'OPR';
    static SUS = 'SUS';
    static ADM = 'ADM';
    static COMUM = 'COMUM';
}